"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _classnames = _interopRequireDefault(require("classnames"));
var _lodash = require("lodash");
var _appendCss = _interopRequireDefault(require("../../utils/appendCss"));
var _Select_css = _interopRequireDefault(require("./Select_css"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
/**
 * Select ("Drop Down") Component
 *
 * @FormGroupCompatible
 * @class Select
 * @extends {Component}
 */
class Select extends _react.Component {
  constructor(props) {
    super(props);
    /**
     * Click Event Handler
     *
     * @memberof Select
     * @param {object} event
     */
    (0, _defineProperty2.default)(this, "handleClick", event => {
      this.setState(previousState => ({
        isOpen: !previousState.isOpen
      }));
    });
    /**
     * Change Event Handler
     *
     * @memberof Select
     * @param {object} event
     */
    (0, _defineProperty2.default)(this, "handleChange", event => {
      if ("onFormValueChanged" in this.props) {
        this.props.onFormValueChanged(event.target.value);
      }
      if ("onChange" in this.props) {
        this.props.onChange(event.target.value);
      }
    });
    (0, _appendCss.default)("arc_slct", _Select_css.default);
    this.state = {
      isOpen: false
    };
    this.inputId = this.props.id ? this.props.id : (0, _lodash.uniqueId)("selectel_");
  }
  render() {
    const {
      options,
      selectedValue,
      isRequired,
      isDisabled,
      label,
      name,
      requiredLabel,
      additionalProps,
      placeHolder
    } = this.props;
    return /*#__PURE__*/_react.default.createElement("div", {
      className: "select__elem"
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "select__labelContainer"
    }, /*#__PURE__*/_react.default.createElement("label", {
      className: (0, _classnames.default)({
        "t-body-small": true,
        "hidden": !Boolean(label) && Boolean(placeHolder)
      }),
      htmlFor: this.inputId
    }, "".concat(Boolean(label) ? label : Boolean(placeHolder) ? placeHolder : "").concat(isRequired && label ? " ".concat(requiredLabel) : ""))), /*#__PURE__*/_react.default.createElement("div", {
      className: "select__wrapper"
    }, /*#__PURE__*/_react.default.createElement("select", (0, _extends2.default)({
      className: (0, _classnames.default)({
        "t-body-large": true,
        "placeholder": placeHolder && selectedValue === ""
      }),
      name: name,
      id: this.inputId,
      onClick: this.handleClick,
      onChange: this.handleChange,
      required: isRequired,
      value: selectedValue,
      disabled: isDisabled
    }, additionalProps), placeHolder && /*#__PURE__*/_react.default.createElement("option", {
      value: "",
      disabled: true,
      hidden: true
    }, placeHolder), options.map(option => {
      return /*#__PURE__*/_react.default.createElement("option", {
        value: option.value || option,
        key: option.value || option
      }, option.title || option);
    }))), /*#__PURE__*/_react.default.createElement("div", {
      className: (0, _classnames.default)({
        "arrow-down": true
      })
    }));
  }
}
Select.propTypes = {
  /** array of objects representing each selectable option */
  options: _propTypes.default.array,
  /** specifies whether element is required in form */
  isRequired: _propTypes.default.bool,
  /** specifies whether element is disabled */
  isDisabled: _propTypes.default.bool,
  /** value of label that sits above element */
  label: _propTypes.default.string,
  /** text of label for required fields */
  requiredLabel: _propTypes.default.string,
  /** HTML name attribute */
  name: _propTypes.default.string,
  /** HTML id attribute */
  id: _propTypes.default.string,
  /** the selected value of available options */
  selectedValue: _propTypes.default.string,
  /** allows for additional key:value pairs to apply to the input HTML element */
  additionalProps: _propTypes.default.object,
  /** initial "unselected" value (ie "Please Select", etc.) */
  placeHolder: _propTypes.default.string
};
Select.defaultProps = {
  isRequired: false,
  isDisabled: false,
  selectedValue: "",
  requiredLabel: "(required)",
  options: []
};
var _default = exports.default = Select;